module.exports = __webpack_public_path__ + "university-ryerson.png?f54aeac8c2fb3f9d8dc1c321d50e42a7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/university-ryerson.png
// module id = 150
// module chunks = 0